export const HOME = {
  emergentLink: 'home-emergent-link',
  navbar: 'navbar',
  navbarLogo: 'navbar-logo',
  navbarLinkProses: 'navbar-link-proses',
  navbarLinkPakej: 'navbar-link-pakej',
  navbarLinkTestimoni: 'navbar-link-testimoni',
  navbarLinkKenapa: 'navbar-link-kenapa',
  navbarLinkFaq: 'navbar-link-faq',
  navbarWhatsappCta: 'navbar-whatsapp-cta',
  navbarMobileMenuButton: 'navbar-mobile-menu-button',
  navbarMobileWhatsappCta: 'navbar-mobile-whatsapp-cta',
  heroPrimaryCta: 'hero-whatsapp-cta',
  heroSecondaryCta: 'hero-view-packages-cta',
  problemSolutionSection: 'problem-solution-section',
  processSection: 'process-section',
  pricingSection: 'pricing-section',
  pricingAsasCta: 'pricing-tier-whatsapp-cta-asas',
  pricingProCta: 'pricing-tier-whatsapp-cta-pro',
  pricingPremiumCta: 'pricing-tier-whatsapp-cta-premium',
  testimonialsSection: 'testimonials-section',
  whyUsSection: 'why-us-section',
  faqSection: 'faq-section',
  finalWhatsappCta: 'final-whatsapp-cta',
  floatingWhatsappButton: 'floating-whatsapp-button',
};
